import { render, staticRenderFns } from "./AddNumberForm.vue?vue&type=template&id=0fd8bde8"
import script from "./AddNumberForm.vue?vue&type=script&lang=js"
export * from "./AddNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports